/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Config from '@/config'
import { restWithCache } from '@/store/lib/search'
import HttpProvider from '@/services/HttpProvider'
import Graphql from '@/services/Graphql'
import { graphqlManageError, giftCardFormDecorator } from '@/helpers'

export default {
  loadCustomerGiftCards (ctx) {
    let url = Config.API.giftCard.customerGiftCards
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    return restWithCache({
      url,
      restPromise: HttpProvider.get(url, {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
        },
        params: {
          'customerEmail': 'tete@eee.com' // ctx.rootState.user.current.email
        }
      })
    })
      .then(res => {
        return ctx.commit('setCustomerGiftCards', res)
      })
      .catch(error => {
        throw new Error(error)
      })
  },
  checkGiftCard (ctx, giftCard) {
    let url = Config.API.giftCard.checkStatus
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
      .replace('{{giftcardCode}}', giftCard)
    return restWithCache({
      url,
      body: url,
      restPromise: HttpProvider.get(url, {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
        }
      })
    })
      .then(res => res)
      .catch(error => {
        ctx.commit('setCurrentGiftCard', null)
        throw error
      })
  },
  // not used anymore
  // addToCart (ctx, { giftOptions, product }) {
  //   return ctx.dispatch('cart/getCartIDMask', {}, { root: true })
  //     .then(() => {
  //       let filters = {
  //         giftCardItem: {
  //           cart_id: ctx.rootState.cart.cartIdMask,
  //           cart_items: [{
  //             aw_giftcard_option: giftCardFormDecorator({ giftOptions, product }),
  //             data: {
  //               quantity: 1,
  //               sku: product.sku
  //             }
  //           }]
  //         }
  //       }
  //       return Graphql.genericCall(
  //         {},
  //         ctx.rootState.user.token,
  //         ctx.rootState.ui.storeViewCode,
  //         'addGiftCardOnCart',
  //         filters,
  //         false
  //       )
  //         .then(res => {
  //           if (res && res.errors) {
  //             throw res.errors[0]
  //           } else {
  //             return res
  //           }
  //         })
  //         .catch(error => {
  //           throw error
  //         })
  //     })
  // },
  addToWishlist (ctx, { giftOptions, product }) {
    let variables = {
      awGcGiftCardOptionsInput: {
        sku: product.sku,
        ...giftCardFormDecorator({ giftOptions, product })
      }
    }
    return Graphql.genericCall(
      {},
      ctx.rootState.user.token,
      ctx.rootState.ui.storeViewCode,
      'addGifCardToWishlist',
      variables,
      false
    )
      .catch(err => {
        console.error(err)
        throw err
      })
      .then((res) => {
        if (graphqlManageError(res)) {
          // eslint-disable-next-line
          throw { body: { result: graphqlManageError(res) } }
        }
        return res
      })
  }
}
